import React from 'react'
import SocialContact from '../../common/social-contact/index'
import './about.css'

function About() {
    return (
        <div className='about'>
            <div className='about-top'>
                <div className="about-info">
                Hi There! 👋, I'm <br /> <span className="info-name">Romit</span> 
                <br />
                ME undergraduating student from NIT Srinagar, an aspiring Full stack developer. I’m passionate about learning new technologies. 
                </div>
                <div className="about-photo">
                 <img  src={require('../../../assets/Coding.png').default   } className="picture"/>
                </div>
            </div>
            <SocialContact />
        </div>
    )
}

export default About
